import React from "react";

const Menu = ({ recipe }) => {
  return (
    <div className="grid justify-center">
      <img
        className="w-52  items-baseline box-border border-2 border-amber-500 rounded-lg"
        src={recipe["recipe"]["image"]}
        alt="error"
      />
      <div className="space-x-4 grid justify-center">
        {recipe["recipe"]["label"]}
      </div>
    </div>
  );
};

export default Menu;
